import {
  type EdgeId,
  type NodeId,
  isNonNullable,
  isPathLookupEdgeData,
  isPathLookupNodeData,
} from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';

/**
 * Node's second edge can be selected from edge or from terminated packets.
 * If theres' only 1 outgoing edge without terminated packets
 * or if there's no edge with only 1 terminated packet,
 * the remaining packet can be autoselected.
 */
export const hasOneRemainingPacketToSelect = (
  graphData: GraphData,
  packetId: EdgeId,
  nodeId: NodeId,
): boolean => {
  const edgeData = graphData.edges[packetId];
  const nodeData = graphData.nodes[nodeId];
  if (edgeData !== undefined && isPathLookupEdgeData(edgeData)) {
    return edgeData.nextEdgeIds.length === 1;
  }
  if (
    nodeData !== undefined &&
    isPathLookupNodeData(nodeData) &&
    isNonNullable(nodeData.generatedPackets?.[packetId]?.nextEdgeIds)
  ) {
    return nodeData.generatedPackets![packetId]?.nextEdgeIds.length === 1;
  }
  return false;
};
